import React, { Fragment } from 'react'
import { get } from 'lodash'
import { Breadcrumb, Card, Col, Layout, Row, Tabs } from 'antd'
import Widget from '../../../components/Project/Dashboard/Widget'
import { numVal, strVal } from '../../../modules/Utils'
import ProjectCont from '../../../components/Project/Projects/ProjectCont'
import { compose } from 'recompose'
import withLoadingSection from '../../../elements/HOC/withLoadingSection'
import DocumentsCont from '../../../components/Common/Documents/DocumentsCont'
import { withRouter } from 'react-router-dom'
import style from '../../../components/Sales/Payments/style.css'
import RefreshButton from '../../../elements/Buttons/RefreshButton'

const { TabPane } = Tabs

const { Content } = Layout
const DocumentsWithLoading = compose(withLoadingSection)(DocumentsCont)
const topColResponsiveProps = {
  xs: 24,
  sm: 24,
  md: 24,
  lg: 24,
  xl: 6,
}

function ProgramsDashboard (props) {
  const {
    list,
    fetching,
    fetchTemplate,
    program,
    fetchProgram,
    fetchingProgram,
  } = props
  const projectCompletionAverage =
    !list &&
    list.map(t => t.completion).reduce((a, b) => a + b, 0) / list.length
  const ProjectDetailWidget = () => (
    <Row>
      <Col {...topColResponsiveProps} xl={24}>
        <Widget
          fetching={fetching}
          title={'Total Projects'}
          iconThemeUpper={'outlined'}
          iconUpper={'exclamation-circle'}
          iconTheme={'outlined'}
          link={`/programs/${program._key}/projects/list`}
          icon={'exclamation-circle'}
          iconColor={'#08c'}
          value={list.length}
          subTitle={[
            `Projects Completion Avg. : ${numVal(projectCompletionAverage)}%`,
            `Projects Completion : ${numVal(program.completion)}%`,
          ]}
          footer={'Project List'}
        />
      </Col>
    </Row>
  )

  return (
    <Content>
      <Card loading={fetchingProgram}>
        <Row gutter={24}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="#/programs/list/">Programs</Breadcrumb.Item>
            <Breadcrumb.Item>
              {strVal(program, 'program.title')}
            </Breadcrumb.Item>
          </Breadcrumb>
          <Row>
            <h1 style={{ marginTop: 20 }} className={style.title}>
              {strVal(program, 'program.title')}
              <RefreshButton onClick={fetchProgram}/>
            </h1>
          </Row>
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <Row gutter={24}>
          <Tabs
            defaultActiveKey={get(props, 'location.hash') || '#vehicles'}
            onChange={key => props.history.push(key)}>
            <TabPane tab="Project List" key="#project-list">
              <ProjectCont disableHeaderDetails={true}/>
            </TabPane>
            <TabPane tab="Details" key="#details">
              <Fragment>
                <Col {...topColResponsiveProps} xl={{ span: 6, offset: 1 }}>
                  <ProjectDetailWidget/>
                </Col>
              </Fragment>
              <Col {...topColResponsiveProps} xl={13}>
                <Row>
                  <Col {...topColResponsiveProps} xl={24}>
                    <DocumentsWithLoading
                      loading={fetching}
                      fetch={fetchTemplate}
                      owner={list}
                      category={false}
                      isWidget={true}
                    />
                  </Col>
                </Row>
                <Row gutter={24}/>
              </Col>
            </TabPane>
          </Tabs>
        </Row>
      </Card>
    </Content>
  )
}

ProgramsDashboard.propTypes = {}
ProgramsDashboard.defaultProps = {}

export default withRouter(ProgramsDashboard)
